import React, { useEffect } from 'react';
import useAgencyDetail from '../use-agency-detail';
import AbilityInfo from './components/ability-info';
import { Loading } from '@tencent/ptp-fe-common';
import { report } from 'store/report';

const Ability: React.FC = () => {
  const agencyDetailProps = useAgencyDetail();

  useEffect(() => {
    report({ event: 'agency_manage', payload: '能力管理' });
  }, []);

  return (
    <div className="ability-info">
      <AbilityInfo {...agencyDetailProps} />
      {agencyDetailProps.loading && <Loading />}
    </div>
  );
};

export default Ability;
